import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/Home.css?vue&type=style&index=0&lang=css"

const __exports__ = script;

export default __exports__